import type { WorkspaceRole } from "@veritrellis/shared/roles";

export const workspaceRoleDescriptions: Record<WorkspaceRole, string> = {
  owner: "Full control, billing, and destructive actions.",
  admin: "Policies, API keys, and membership (except owner-only transfers).",
  developer: "Build and configure in sandbox; production policy changes follow strict mode rules.",
  approver: "Approve or reject pending requests.",
  viewer: "Read requests, audit, and dashboards only.",
  auditor: "Read-only access across audit and operational views."
};

export const workspaceRoleBadgeVariant = (
  role: WorkspaceRole
): "secondary" | "default" | "warning" | "outline" => {
  if (role === "owner") return "warning";
  if (role === "approver" || role === "admin") return "default";
  if (role === "developer") return "outline";
  return "secondary";
};

export const workspaceRolesOrdered: WorkspaceRole[] = [
  "owner",
  "admin",
  "developer",
  "approver",
  "viewer",
  "auditor"
];
